import React, { useState, useEffect, useRef } from "react";
import classes from "./MyInput.module.scss";
import axios from "axios";
import CustomRadio from "../radio/CustomRadio";
import { useDispatch } from "react-redux";
import { setBrandName, setIndustry } from "../../../store/scrappingSlice";

const MyInput = ({
  save,
  industry,
  onChange,
  setSelectedOption,
  option,
  error,
  setEventProperties,
  sessionId,
  setEventName,
  bName,
  ...props
}) => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [loadingImages, setLoadingImages] = useState({});

  const containerRef = useRef(null);
  const ulRef = useRef(null);

  function businessProfiles(value) {
    var profilesJSON = localStorage.getItem("business-profiles");
    if (profilesJSON) {
      var profiles = JSON.parse(profilesJSON);
      profiles.forEach(function (profile) {
        profile.businessArea = value;
      });
      var updatedProfilesJSON = JSON.stringify(profiles);
      localStorage.setItem("business-profiles", updatedProfilesJSON);
    } else {
      var newProfile = {
        businessArea: value,
      };
      var newProfiles = [newProfile];
      var newProfilesJSON = JSON.stringify(newProfiles);
      localStorage.setItem("business-profiles", newProfilesJSON);
    }
  }

  useEffect(() => {
    axios
      .get("./data/industry-new.json")
      .then((res) => {
        setOptions(
          res.data.map((option) => ({
            ...option,
            visible: option.label.toLowerCase().includes(""),
          }))
        );

        const imagePromises = res.data
          .filter((option) => option.img)
          .map((option) => {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = `${process.env.PUBLIC_URL}/img/business-industry/${option.label}.webp`;
              img.onload = () => {
                setLoadingImages((prevState) => ({
                  ...prevState,
                  [option.label]: true,
                }));
                resolve();
              };
              img.onerror = () => {
                setLoadingImages((prevState) => ({
                  ...prevState,
                  [option.label]: false,
                }));
                reject();
              };
            });
          });

        Promise.all(imagePromises).catch((err) =>
          console.error("Ошибка загрузки изображения:", err)
        );
      })
      .catch((err) => console.log(err));
  }, []);

  const [selectedRadio, setSelectedRadio] = useState("sdsadsad");

  const imgbarea =
    "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";

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
    // onChange(event.target.value);
    setIsActive(true);

    setOptions(
      options.map((option) => ({
        ...option,
        visible: option.label
          .toLowerCase()
          .includes(event.target.value.toLowerCase()),
      }))
    );
  };

  function arrowClick() {
    setIsActive(true);
    setOptions(
      options.map((option) => ({
        ...option,
        visible: option.label.toLowerCase().includes(""),
      }))
    );
  }

  useEffect(() => {
    if (industry && save && options && options.length > 0) {
      setIsActive(true);

      // setOptions(
      //   options.map(option => ({
      //     ...option,
      //     visible: option.label.toLowerCase().includes(searchTerm.toLowerCase())
      //   }))
      // );
    }
  }, [searchTerm, options]);

  useEffect(() => {
    if (industry && save) {
      handleRadioClick(industry);
    }
  }, [industry]);

  const handleOptionClick = (option) => {
    onChange(option.label);
    setSearchTerm(option.label);
    setIsActive(false);
  };

  const handleRadioClick = (value, nextFunction) => {
    onChange(value);
    setSelectedRadio(value);
    businessProfiles(value);
    setSelectedOption(value);
    // if (ulRef.current) {
    //   ulRef.current.scrollTo({
    //   top: 0,
    //   behavior: 'smooth'
    //   });
    // }
    // setSelectedOption('1')
    // setEventName('web_industry')
    // setEventProperties({
    //   session_id: sessionId,
    //   web_entrance: 'signup',
    //   web_industry_answer: value
    // })
  };


  return (
    <div
      className={`${classes.searchContainer} ${isActive ? classes.active : ""}`}
      ref={containerRef}
    >
      <input
        type="text"
        value={searchTerm}
        onChange={handleChange}
        className={classes.myInput}
        {...props}
      />
      <div className={classes.search}>
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8.5" r="6.35" stroke="black" strokeWidth="1.3" />
          <path
            d="M12.5 13.5L15.5 16.5"
            stroke="black"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className={classes.arrow} onClick={arrowClick}>
        <svg
          width="18"
          height="19"
          viewBox="0 0 18 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.41 5.78922L9 10.3692L13.59 5.78922L15 7.19922L9 13.1992L3 7.19922L4.41 5.78922Z"
            fill="#A7A8AA"
          />
        </svg>
      </div>
      <div className={classes.optionsWrapper}>
        {isActive && (
          <ul className={`${classes.options} ${bName ? classes.bname : ""}`}
            style={{ display: "flex", flexDirection: "column" }}
            ref={ulRef}
          >
            {industry && !options.some((option) => option.label === industry) && (
              <CustomRadio
                checked={selectedRadio === industry}
                onClick={() => handleRadioClick(industry)}
                name="country"
                style={{ height: "44rem", marginBottom: "24rem" }}
                className={error ? "error" : undefined}
              >
                <img src={`data:image/png;base64,${imgbarea}`} alt="" />
                {industry}
              </CustomRadio>
            )}


            {options
              .filter((option) => option.visible)
              .map((option, index) => (
                <CustomRadio
                  checked={selectedRadio === option.label}
                  onClick={() => handleRadioClick(option.label)}
                  key={index}
                  name="country"
                  style={{ height: "44rem", marginBottom: "24rem", order: ((selectedRadio === option.label) && (selectedRadio === industry) && save) ? -1 : 0 }}
                  className={error ? "error" : undefined}
                >
                  {option.img ? (
                    loadingImages[`${option.label}`] ? (
                      <img
                        src={`${process.env.PUBLIC_URL}/img/business-industry/${option.label}.webp`}
                        alt=""
                      />
                    ) : (
                      <div
                        className="skeleton-loader"
                        style={{
                          background: "gray",
                          width: "44rem",
                          height: "44rem",
                          borderRadius: "50%",
                          overflow: "hidden",
                          position: "relative",
                          marginRight: "12rem",
                        }}
                      >
                        {/* Skeleton loader */}
                        {/* <img style={{ width: '100%' }} src={process.env.PUBLIC_URL + `/img/${imgCV}`} alt="" /> */}
                      </div>
                    )
                  ) : (
                    <img src={`data:image/png;base64,${imgbarea}`} alt="" />
                  )}
                  {option.label}
                </CustomRadio>
              ))}
            {searchTerm !== "" && !options.some((option) => option.label.toLowerCase() === searchTerm.toLowerCase()) && (

              <CustomRadio
                checked={selectedRadio === searchTerm}
                onClick={() => handleRadioClick(searchTerm)}
                name="country"
                style={{ height: "44rem", marginBottom: "24rem", }}
                className={error ? "error" : undefined}
              >
                <img src={`data:image/png;base64,${imgbarea}`} alt="" />
                {searchTerm}
              </CustomRadio>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MyInput;
